// Monthly average USD/TRY exchange rates (display month -> rate)
export const USD_TRY_RATES = {
  '2024-01': 30.13, '2024-02': 30.87, '2024-03': 31.98, '2024-04': 32.39,
  '2024-05': 32.29, '2024-06': 32.56, '2024-07': 32.87, '2024-08': 33.61,
  '2024-09': 33.94, '2024-10': 34.20, '2024-11': 34.42, '2024-12': 34.84,
  '2025-01': 35.52, '2025-02': 36.17, '2025-03': 37.09, '2025-04': 38.13,
  '2025-05': 38.83, '2025-06': 39.48, '2025-07': 40.18, '2025-08': 40.79,
  '2025-09': 41.28, '2025-10': 41.79, '2025-11': 42.24, '2025-12': 42.70,
  '2026-01': 43.06, '2026-02': 43.40,
};

// Demo brand for overview (use dummy data only for this brand)
export const DEMO_BRAND_ID = 'ec9873c2-0edb-44eb-ac6f-2670c8e56dc4';

export function isDemoBrand(brandId) {
  return brandId === DEMO_BRAND_ID;
}

// Show special duplicate table only for specific brands
export const ALLOWED_BRAND_IDS_FOR_CATEGORY_TABLE = new Set([
  'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e',
  '44e35dfe-0186-495d-a0cc-db5e7e459ab7',
  'dfcf54dd-b00d-434a-be1e-27b6484848eb',
  '7fc8e68d-f2ba-4101-95f7-acece386ab8f',
]);

export const API_BASE_URL = 'https://api.glowytics.com';

// Date filter presets
export const DATE_FILTERS = [
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last7', label: '7 Days' },
  { value: 'last30', label: '30 Days' },
  { value: 'thisMonth', label: 'This Month' },
  { value: 'lastMonth', label: 'Last Month' },
  { value: 'last90', label: '90 Days' },
  { value: 'all', label: 'All Time' },
];

// Chart styling
export const CHART_COLORS = {
  currentPeriod: {
    borderColor: '#3b82f6',
    backgroundColor: 'rgba(59,130,246,0.08)',
  },
  previousPeriod: {
    borderColor: '#9CA3AF',
    backgroundColor: 'transparent',
  },
  doughnut: ['#3B82F6', '#10B981', '#F59E0B', '#8B5CF6', '#EC4899'],
};

export const CHART_DATASET_CURRENT = {
  label: 'Current Period',
  borderColor: '#3b82f6',
  backgroundColor: 'rgba(59,130,246,0.08)',
  fill: true,
  tension: 0.35,
  pointRadius: 2,
  borderWidth: 2,
};

export const CHART_DATASET_PREVIOUS = {
  label: 'Previous Period',
  borderColor: '#9CA3AF',
  backgroundColor: 'transparent',
  fill: false,
  borderDash: [4, 4],
  tension: 0.35,
  pointRadius: 0,
  borderWidth: 1.5,
};

export const PERFORMANCE_CHART_OPTIONS = {
  plugins: { legend: { display: false } },
  scales: {
    y: { beginAtZero: true, grid: { color: '#f3f4f6' } },
    x: { grid: { display: false } },
  },
};

// Metric selector options
export const METRIC_OPTIONS = [
  { key: 'totalSales', label: 'Revenue' },
  { key: 'saleCount', label: 'Sessions' },
  { key: 'sessionCount', label: 'Users' },
  { key: 'conversionRate', label: 'Conv. Rate' },
  { key: 'refundAmount', label: 'Events' },
];

// Funnel step definitions
export const FUNNEL_STEPS = [
  { eventName: 'view_item', label: 'Product Views', icon: 'Eye', color: '#3B82F6' },
  { eventName: 'add_to_cart', label: 'Add to Cart', icon: 'ShoppingCart', color: '#10B981' },
  { eventName: 'view_cart', label: 'View Cart', icon: 'ShoppingBag', color: '#F59E0B' },
  { eventName: 'begin_checkout', label: 'Checkout', icon: 'CreditCard', color: '#8B5CF6' },
  { eventName: 'purchase', label: 'Purchase', icon: 'CheckCircle', color: '#EC4899' },
];
